module.exports = __webpack_public_path__ + "img/1491270687.8367a3c1.jpg";